import { Avatar, type AvatarProps } from '@mantine/core'
import { useEffect, useRef, useState } from 'react'

import fallbackHeadshot from '@/assets/icons/account-user.svg?url'

interface Props extends AvatarProps {
  src?: string
  size: number
  showFallbackOnError?: boolean
}

/**
 * Port of cdc-web `src/components/knockOuts/PlayerHeadshot.tsx`（1:1）。
 * 选手头像：加载失败回退到固定的 `#A0A9BE` 线稿人形 SVG（两主题一致，不分裂）。
 * `account-user.svg` 已从 cdc-web 拷到 `src/assets/icons/`。
 */
const PlayerHeadshot = ({
  src,
  size,
  alt = '',
  showFallbackOnError = true,
  ...rest
}: Readonly<Props>) => {
  const [hasError, setHasError] = useState(false)
  const avatarRef = useRef<HTMLDivElement>(null)
  const fallbackSrc = fallbackHeadshot

  useEffect(() => {
    setHasError(false)
  }, [src])

  // Check if the image has already failed before hydration
  useEffect(() => {
    const img = avatarRef.current?.querySelector('img')
    if (img?.complete && img.naturalWidth === 0 && src) {
      setHasError(true)
    }
  }, [src])

  const resolvedSrc = !src || hasError ? (showFallbackOnError ? fallbackSrc : null) : src

  if (!resolvedSrc) return null

  return (
    <Avatar
      ref={avatarRef}
      src={resolvedSrc}
      size={size}
      radius={0}
      alt={alt}
      onError={() => setHasError(true)}
      style={{ '--avatar-bg': 'none' }}
      {...rest}
    />
  )
}

export default PlayerHeadshot
